import React from 'react';
import { 
  Activity, 
  RefreshCw
} from 'lucide-react';

export const Header = ({ 
  onRefresh, 
  countdown, 
  lastUpdated, 
  apiError
}) => {
  // Format timestamp in 12-hour format with AM/PM
  const formattedTime = lastUpdated 
    ? lastUpdated.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })
    : '';

  return (
    <header className="glass-card" style={{ marginBottom: '24px', borderRadius: '18px', padding: '18px 24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
        
        {/* FarmTv Brand Identity with logo image */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{
            padding: '6px 12px',
            borderRadius: '12px',
            background: 'rgba(16, 185, 129, 0.08)',
            border: '1px solid rgba(16, 185, 129, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
          }}>
            <img 
              src={process.env.PUBLIC_URL + '/logo.png'} 
              alt="FarmTv Logo" 
              style={{ height: '42px', width: 'auto', objectFit: 'contain' }} 
            />
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <h1 style={{ fontSize: '1.45rem', fontWeight: 800, letterSpacing: '-0.02em', color: '#ffffff' }}>
                Farm<span style={{ color: '#34d399' }}>Tv</span>
              </h1>
              <span className={`badge-status ${apiError ? 'unhealthy' : 'healthy'}`} style={{ fontSize: '0.65rem' }}>
                <Activity size={12} /> {apiError ? 'Connection Error' : 'Live Metrics'}
              </span>
            </div>
            <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: '2px' }}>
              Stream Health & Infrastructure Monitoring
            </p>
          </div>
        </div>

        {/* Live Controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
          
          {/* Polling Timer & Last Updated 12-hour Time */}
          <div style={{ 
            fontSize: '0.8rem', 
            color: 'var(--text-muted)', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px',
            background: 'rgba(16, 185, 129, 0.05)',
            padding: '8px 14px',
            borderRadius: '10px',
            border: '1px solid rgba(16, 185, 129, 0.12)'
          }}>
            <span className={`pulse-dot ${apiError ? 'danger' : ''}`} />
            <span>Refreshing in <strong style={{ color: '#34d399' }}>{countdown}s</strong></span>
            {formattedTime && (
              <>
                <span style={{ color: 'rgba(16, 185, 129, 0.3)' }}>|</span>
                <span>Last updated: <strong style={{ color: 'var(--text-main)' }}>{formattedTime}</strong></span>
              </>
            )}
          </div>

          {/* Manual Refresh Button */}
          <button className="btn-emerald" onClick={onRefresh}>
            <RefreshCw size={14} />
            Refresh
          </button>
        </div>

      </div>
    </header>
  );
};
